import React, { useState, useEffect } from "react";
import styles from "./FormBuilder.module.css";

const FormBuilder = ({
  steps = [],
  stepContents = [],
  initialStep = 0,
  onStepChange = () => {},
  currentStep,
  setCurrentStep,
}) => {
  const activeStep = currentStep ?? initialStep;

  useEffect(() => {
    onStepChange(activeStep);
  }, [activeStep]);

  const handleStepClick = (index) => {
    if (index > currentStep) {
      // Only allow forward clicks if all previous steps are complete
      // You can also add your own validation logic here if needed
      setCurrentStep(index);
    } else {
      // Allow going back to previous steps
      setCurrentStep(index);
    }
  };
  

  return (
    <div className={styles.formBuilderContainer}>
      <div className={styles.stepHeaderWrapper}>
        <div className={styles.stepHeader}>
          {steps.map((step, index) => (
            <div
              key={step.id || index}
              className={styles.stepWrapper}
              onClick={() => handleStepClick(index)}
            >
              <div
                className={`${styles.circle} ${
                  index <= activeStep ? styles.activeCircle : ""
                }`}
              >
                {step.id || index + 1}
              </div>
              <div
                className={`${styles.label} ${
                  index <= activeStep ? styles.activeLabel : ""
                }`}
              >
                {step.label}
              </div>
              {index < steps.length - 1 && (
                <div className={styles.divider}></div>
              )}
            </div>
          ))}
        </div>
      </div>

      <div className={styles.stepBody}>
        {stepContents[activeStep] || <p>No content for this step</p>}
      </div>
    </div>
  );
};

export default FormBuilder;
